export default {
  workFromHomeText: {
    '1': 'Employees HAVE to work from home.',
    '2': 'Employees are ENCOURAGED to work from home.',
    '3': 'Employees CAN work from home if they\'d like.',
    '4': 'Employees CAN work from home only if they\'re sick of if they recently traveled to high-risk countries.',
    '5': 'Employees HAVE to work from the office.',
  },

  travelText: {
    '1': 'Employees are ALLOWED to travel.',
    '2': 'Employees are DISCOURAGED from travelling.',
    '3': 'Employees are NOT ALLOWED to travel.',
  },

  visitorsText: {
    '1': 'Visitors are ALLOWED.',
    '2': 'Visitors are DISCOURAGED from attending.',
    '3': 'NOT ACCEPTING any visitors at the moment.',
  },

  eventsText: {
    '1': 'Events are ALLOWED.',
    '2': 'Events are DISCOURAGED.',
    '3': 'Events are NOT ALLOWED.',
  },

  usesGitText: {
    '0': 'Tech team is not using git for development',
    '1': 'Tech team uses git for development.',
  },

  videoConferenceText: {
    '0': 'Not using any video conference tools.',
    '1': 'Use video conference tools.',
  },

  projectManagementText: {
    '0': 'Not using any project management tools.',
    '1': 'Use project management tools.',
  },

  clearSOPText: {
    '0': 'No clear SOPs in place.',
    '1': 'Clearly defined SOPs in place for employees to follow.',
  },

  // maps to the shared cloud storage question
  setCommsProtocolText: {
    '0': 'Employees don\'t use a cloud storage, and collaboration platform like Google Drive, etc.',
    '1': 'Employees use a shared cloud storage, and collaboration platform like Google Drive, etc.',
  },

  scheduleRegularScrumText: {
    '0': 'No virtual meetings.',
    '1': 'Regular virtual meetings with the tech team.',
  },

  helpRemoteReadyText: {
    '0': 'You\'re team is fully prepared for remote work.',
    '1': 'You\'d like us to help prepare your team for remote work.',
  },
};
